var map = {
	"./assert": 303,
	"./assert.js": 303,
	"./behavior": 305,
	"./behavior.js": 305,
	"./call": 306,
	"./call.js": 306,
	"./collection": 307,
	"./collection.js": 307,
	"./extend": 308,
	"./extend.js": 308,
	"./format": 309,
	"./format.js": 309,
	"./log_error": 314,
	"./log_error.js": 314,
	"./match": 315,
	"./match.js": 315,
	"./mock": 316,
	"./mock.js": 316,
	"./sandbox": 317,
	"./sandbox.js": 317,
	"./spy": 318,
	"./spy.js": 318,
	"./stub": 319,
	"./stub.js": 319,
	"./test": 320,
	"./test.js": 320,
	"./test_case": 321,
	"./test_case.js": 321,
	"./times_in_words": 322,
	"./times_in_words.js": 322,
	"./typeOf": 323,
	"./typeOf.js": 323,
	"./util/core": 324,
	"./util/core.js": 324,
	"./util/event": 326,
	"./util/event.js": 326,
	"./util/fake_server": 327,
	"./util/fake_server.js": 327,
	"./util/fake_server_with_clock": 328,
	"./util/fake_server_with_clock.js": 328,
	"./util/fake_timers": 329,
	"./util/fake_timers.js": 329,
	"./util/fake_xdomain_request": 331,
	"./util/fake_xdomain_request.js": 331,
	"./util/fake_xml_http_request": 332,
	"./util/fake_xml_http_request.js": 332,
	"./util/timers_ie": 333,
	"./util/timers_ie.js": 333,
	"./util/xdr_ie": 334,
	"./util/xdr_ie.js": 334,
	"./util/xhr_ie": 335,
	"./util/xhr_ie.js": 335,
	"./walk": 336,
	"./walk.js": 336
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 304;



//////////////////
// WEBPACK FOOTER
// ./~/sinon/lib/sinon ^\.\/.*$
// module id = 304
// module chunks = 1